import { render, staticRenderFns } from "./RestaurantEditForm.vue?vue&type=template&id=2763adb2&lang=html&"
import script from "./RestaurantEditForm.vue?vue&type=script&lang=js&"
export * from "./RestaurantEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports